import React from "react";
import StatusScreen from "./StatusScreen";

/**
 * Link-not-found / 404. Rewritten to the shared StatusScreen (owner 2026-07-16) — replaces the
 * cluttered two-column card with floating icons + troubleshooting list. Same no-prop API, so every
 * call site keeps working.
 */
export default function LinkNotFound() {
  return (
    <StatusScreen
      variant="error"
      title="Link Not Found"
      message="This registration link is invalid, expired, or has been removed. Please double-check the link, or ask the event organizer for a fresh one."
      actions={[
        { label: "Go Home", primary: true, href: "https://eventegration.com" },
        { label: "Retry", onClick: () => window.location.reload() },
      ]}
    />
  );
}
